import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { LuClock2 } from "react-icons/lu";
import { Box, Modal, Grid } from "@mui/material";
import * as XLSX from "xlsx";
import apiEndPoint from "../../../services/apiService/apiEndPoints";
import { getApi, postApi } from "../../../services/apiService/fetchMethod";
import MainLoader from "../../../commonComponents/loader/MainLoader";
import { useSelector } from "react-redux";
import LoaderCircle from "../../../commonComponents/loader/LoaderCircle";
import InfiniteScroll from "react-infinite-scroll-component";
import FilterBox from "../../../commonComponents/filterBox/FilterBox";
import { Button, Divider, Empty, Flex, Tag, message } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { BsX } from "react-icons/bs";
import { FaRegClock } from "react-icons/fa";
import { PiClockCounterClockwiseBold } from "react-icons/pi";
import { GiBallPyramid } from "react-icons/gi";
import CardComp from "../../../components/home/CardComp";

function Reports() {
  const [graphData, setGraphData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [noData, setNodata] = useState(false);
  const [loading, setLoading] = useState(true);
  const [open2, setOpen2] = useState(false);
  const [dataForModel, setDataForModel] = useState([]);
  const { mode, selectedRangeDate, multiDate, selectedTabAll } = useSelector(
    (state) => state.filter
  );
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true, // Enable 12-hour clock
    };
    return date.toLocaleDateString("en-US", options);
  }
  const handleDownload = (jsonData) => {
    if (!jsonData) {
      message.error("Somthing went wrong");
    }
    let dataVal = [];
    if (jsonData.lc) {
      dataVal = jsonData.lc.map((item, i) =>
        item.map((item2) =>
          item2.map((item3) => ({ [`LC${i} ${item3.name}`]: item3 }))
        )
      );
    }


    return;
    const ws = XLSX.utils.json_to_sheet([
      { TIME: "00:00min", LC0: 0, ROI0: 1 },
      { TIME: "00:01min", LC0: 0, ROI0: 1, ROI1: 1 },
      { TIME: "00:02min", LC03: 0, ROI03: 1, ROI13: 1 },
    ]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${jsonData?.videoId?.title}.xlsx`);
  };
  useEffect(() => {
    (async () => {
      let token = localStorage.getItem("Token");
      if (!token) {
        setLoading(false);
      }

      let sortUrl =
        selectedTabAll === "camera"
          ? apiEndPoint().GET_GRAPH_DATA_LIVE
          : apiEndPoint().GET_GRAPH_DATA;

      const url =
        sortUrl +
        `?pageNumber=${pageNumber}&mode=${mode}&filter=${
          mode === 0
            ? selectedRangeDate
                ?.map((date) => date.format("YYYY-MM-DD"))
                ?.toString()
            : multiDate
                ?.map((date) => {
                  if (date?.calendar) {
                    return date?.format("YYYY-MM-DD");
                  } else {
                    return date;
                  }
                })
                ?.toString()
        }`;
      const { status, data } = await getApi({ url });
      if (status === 200) {
        if (data?.data?.length === 0) {
          setNodata(true);
        }
        setGraphData((pre) => [...pre, ...data.data]);
      }
      setLoading(false);
    })();
  }, [ mode, selectedRangeDate, multiDate, pageNumber,selectedTabAll]);
  
  useEffect(() => {
    setGraphData([]);
    setPageNumber(0);
    setLoading(true)
  }, [mode, selectedRangeDate, multiDate,selectedTabAll]);
  
  const handleOpen = async (id) => {
    try {
      const url = apiEndPoint().EVENTBYPIPELINEID;
      const { status, data } = await postApi({ url, params: { id } });
      if (status === 200) {
        setDataForModel(data.data);
      }
    } catch (error) {
      console.log(error);
      message.error("SOmthing went wrong");
    }
    setOpen2(true);
  };
  const handleClose2 = () => setOpen2(false);
  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "80%",
    height: "80%",
    transform: "translate(-50%, -50%)",
    borderRadius: "8px",
    overflow: "auto",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };
  function findLargestValueIndex(arr) {
    let maxIndex = 0;
    for (let i = 1; i < arr.length; i++) {
      if (arr[i] > arr[maxIndex]) {
        maxIndex = i;
      }
    }
    return { index: maxIndex, val: arr[maxIndex] };
  }
  function calculateAverage(numbers) {
    if (numbers.length === 0) {
      return 0;
    }
    const sum = numbers.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    const average = sum / (numbers.length - 1);
    return average;
  }
  const fetchMoreData = () => {
    setPageNumber((pre) => pre + 1);
  };
 
  if (loading) {
    return <MainLoader />;
  }
  return (
    <div className="container">
      <h4 className="dashHeading">Reports</h4>
      <div className=" d-flex justify-content-end">
        <FilterBox />
      </div>
      {graphData.length === 0 ? (
        <div
          className=" d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Empty />
        </div>
      ) : (
        <InfiniteScroll
          className="example2"
          dataLength={graphData.length}
          next={fetchMoreData}
          hasMore={true}
          loader={
            <div className="d-flex justify-content-center align-items-center mt-3">
              {noData ? <div></div> : <LoaderCircle size={30} />}
            </div>
          }
        >
          {graphData.map((item, index) => (
            <div key={index} className="px-5 pt-3  pb-5 mb-5 reportBox">
              <div style={{ marginBottom: "2rem" }}>
                <div className=" d-flex justify-content-between align-items-center">
                  <div>
                    <h4 style={{ fontWeight: "600" }}>
                      {item?.videoId?.title}
                    </h4>
                    <Flex gap="4px 0" wrap="wrap">
                      {item.alertName.map((item2, i) => (
                        <Tag color="success" key={i}>
                          {item2}
                        </Tag>
                      ))}
                    </Flex>
                    <div className="d-flex align-items-center mt-1">
                      <LuClock2 color="blue" />{" "}
                      <div className="headingReport mx-2">
                        {formatDate(item.createdAt)}
                      </div>
                    </div>
                  </div>
                  <div className=" d-flex align-items-center">
                    {item.violation.length !== 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          marginBlock: "1rem",
                        }}
                      >
                        <Button
                          type="primary"
                          icon={<EyeOutlined />}
                          onClick={() => handleOpen(item.pipelineId?._id)}
                        >
                          View violation
                        </Button>
                      </div>
                    )}
                    {/* <Tooltip
                      title="Download Report"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDownload(item)}
                    >
                      <div className="icon2 ms-3">
                        <FaFileDownload />
                      </div>
                    </Tooltip> */}
                  </div>
                </div>
                <Divider />
              </div>
              <Grid container spacing={5} key={index}>
                {item.lc &&
                  item.lc.map((item2, i) => (
                    <Grid item xs={12} sm={selectedTabAll?12:6} key={i}>
                      <div className="graphBoxShadow">
                        <Grid container spacing={5}>
                          {item2.map((item3, i) => (
                            <Grid item xs={12} sm={selectedTabAll?12:6} key={i}>
                              <div className="card2">
                                <div className="cardInnerBox">
                                  <div className="icon2">
                                    <FaRegClock size={18} />
                                  </div>
                                  <div className="content2">
                                    <span className="title2">
                                      {item3.name} Peak Time
                                    </span>
                                    <div className="desc2">
                                      {
                                        item3.options.xaxis.categories[
                                          findLargestValueIndex(item3.data)
                                            .index - 1
                                        ]
                                      }{" "}
                                      {"-"}{" "}
                                      {
                                        item3.options.xaxis.categories[
                                          findLargestValueIndex(item3.data)
                                            .index
                                        ]
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div className="cardInnerBox">
                                  <div className="icon2">
                                    <PiClockCounterClockwiseBold size={22} />
                                  </div>
                                  <div className="content2">
                                    <span className="title2">
                                      Count at Peak Time{" "}
                                    </span>
                                    <div className="desc2">
                                      {findLargestValueIndex(item3.data).val}
                                    </div>
                                  </div>
                                </div>
                                <div className="cardInnerBox">
                                  <div className="icon2">
                                    <GiBallPyramid size={20} />
                                  </div>
                                  <div className="content2">
                                    <span className="title2">Total Count </span>
                                    <div className="desc2">
                                      {item3?.data?.reduce(
                                        (accumulator, currentValue) =>
                                          accumulator + currentValue,
                                        0
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Grid>
                          ))}
                        </Grid>
                        <Divider />
                        {item2[0] && item2[0].options ? (
                          <Chart
                            series={item2}
                            height={300}
                            options={item2[0].options}
                          />
                        ) : (
                          "Somthing Went wrong"
                        )}
                      </div>
                    </Grid>
                  ))}
                {item.roi &&
                  item.roi.map((item2, i) => (
                    <Grid item xs={12} sm={selectedTabAll?12:6} key={i}>
                      <div className="graphBoxShadow">
                        <Grid container spacing={5}>
                          {item2.map((item3, i) => (
                            <Grid item xs={12} sm={selectedTabAll?12:6} key={i}>
                              <div className="card2">
                                <div className="cardInnerBox">
                                  <div className="icon2">
                                    <FaRegClock size={18} />
                                  </div>
                                  <div className="content2">
                                    <span className="title2">
                                      {item3.name} Peak Time
                                    </span>
                                    <div className="desc2">
                                      {
                                        item3.options.xaxis.categories[
                                          findLargestValueIndex(item3.data)
                                            .index - 1
                                        ]
                                      }{" "}
                                      {"-"}{" "}
                                      {
                                        item3.options.xaxis.categories[
                                          findLargestValueIndex(item3.data)
                                            .index
                                        ]
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div className="cardInnerBox">
                                  <div className="icon2">
                                    <PiClockCounterClockwiseBold size={22} />
                                  </div>
                                  <div className="content2">
                                    <span className="title2">
                                      Count at Peak Time{" "}
                                    </span>
                                    <div className="desc2">
                                      {findLargestValueIndex(item3.data).val}
                                    </div>
                                  </div>
                                </div>
                                <div className="cardInnerBox">
                                  <div className="icon2">
                                    <GiBallPyramid size={20} />
                                  </div>
                                  <div className="content2">
                                    <span className="title2">
                                      Average Count{" "}
                                    </span>
                                    <div className="desc2">
                                      {calculateAverage(item3?.data)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Grid>
                          ))}
                        </Grid>
                        <Divider />
                        {item2[0] && item2[0].options ? (
                          <Chart
                            series={item2}
                            height={300}
                            options={item2[0].options}
                          />
                        ) : (
                          "Somthing Went wrong"
                        )}
                      </div>
                    </Grid>
                  ))}
                {!!item.violation.length && (
                  <Grid item xs={12} sm={selectedTabAll?12:6}>
                    {item.violation.length && (
                      <div className="graphBoxShadow">
                        <Grid container spacing={5}>
                          {item.violation.map((item3, i) => (
                            <Grid item xs={12} sm={selectedTabAll?12:6} key={i}>
                              <div className="card2">
                                <div className="cardInnerBox">
                                  <div className="icon2">
                                    <FaRegClock size={18} />
                                  </div>
                                  <div className="content2">
                                    <span className="title2">
                                      {item3.name} Peak Time
                                    </span>
                                    <div className="desc2">
                                      {
                                        item3.options.xaxis.categories[
                                          findLargestValueIndex(item3.data)
                                            .index - 1
                                        ]
                                      }{" "}
                                      {"-"}{" "}
                                      {
                                        item3.options.xaxis.categories[
                                          findLargestValueIndex(item3.data)
                                            .index
                                        ]
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div className="cardInnerBox">
                                  <div className="icon2">
                                    <PiClockCounterClockwiseBold size={22} />
                                  </div>
                                  <div className="content2">
                                    <span className="title2">
                                      Count at Peak Time{" "}
                                    </span>
                                    <div className="desc2">
                                      {findLargestValueIndex(item3.data).val}
                                    </div>
                                  </div>
                                </div>
                                <div className="cardInnerBox">
                                  <div className="icon2">
                                    <GiBallPyramid size={20} />
                                  </div>
                                  <div className="content2">
                                    <span className="title2">Total Count </span>
                                    <div className="desc2">
                                      {item3?.data?.reduce(
                                        (accumulator, currentValue) =>
                                          accumulator + currentValue,
                                        0
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Grid>
                          ))}
                        </Grid>
                        <Divider />
                        <Chart
                          series={item.violation}
                          height={300}
                          options={item.violation[0]?.options}
                        />
                      </div>
                    )}
                  </Grid>
                )}
              </Grid>
            </div>
          ))}
        </InfiniteScroll>
      )}
      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          <BsX
            className="iconCross"
            size={22}
            onClick={() => setOpen2(false)}
          />
          <CardComp data={dataForModel} />
        </Box>
      </Modal>
      
    </div>
  );
}

export default Reports;
